import(/* webpackMode: "eager" */ "/vercel/path0/src/components/rooms/RoomsComponent.tsx")